<router-outlet></router-outlet>
<ngx-loading-bar [color]="loadingBarColor"></ngx-loading-bar>
<itorum-call-acceptor></itorum-call-acceptor>
